module.exports = __webpack_public_path__ + "img/banner04.73be37fb.png";